var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16089 7.00489L12.0209 1.04982C13.315 -0.0734844 15.1839 1.01142 15.1839 3.14572V20.8526C15.1839 22.9577 13.3363 24.0828 12.0259 22.9527L5.10425 16.9835H2.71555C1.53694 16.9835 0.578125 16.0243 0.578125 14.8452V9.14316C0.578125 7.96408 1.53694 7.00489 2.71555 7.00489H5.16089ZM2.00307 9.14316V14.8452C2.00307 15.2382 2.32271 15.558 2.71555 15.558H4.85297V8.4304H2.71555C2.32271 8.4304 2.00307 8.75016 2.00307 9.14316ZM13.2725 21.9474C13.5142 21.8366 13.7589 21.425 13.7589 20.8526V3.14572C13.7589 2.57271 13.5139 2.16109 13.2719 2.05066C13.1938 2.01493 13.1012 1.99943 12.9548 2.12657L6.27792 7.92261V16.1135L12.9563 21.8731C13.1023 21.9989 13.1946 21.9831 13.2725 21.9474ZM21.0012 11.7867L23.1656 13.9219C23.6207 14.3709 23.2968 15.1422 22.6653 15.1421C22.4847 15.1421 22.3039 15.0738 22.1651 14.9369L20.0007 12.8016L17.8662 14.9669C17.7268 15.1084 17.5429 15.1792 17.3589 15.1792C16.7312 15.1792 16.4075 14.4166 16.8516 13.966L18.986 11.8007L16.8216 9.66546C16.5414 9.38904 16.5383 8.93778 16.8145 8.65749C17.0908 8.3772 17.5419 8.37399 17.8221 8.65045L19.9866 10.7857L22.121 8.62042C22.3972 8.34013 22.8484 8.33693 23.1286 8.61339C23.4088 8.8898 23.4119 9.34107 23.1356 9.62136L21.0012 11.7867Z",
    fill: "#2C2C2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMuted);
export default __webpack_public_path__ + "static/media/ic_muted.be1cbdfbf611ea124ffd88d9e7c85ad7.svg";
export { ForwardRef as ReactComponent };